<template>
  <div v-loading.fullscreen.lock="loading" :element-loading-text="$t('loading')" :class="['aui-wrapper', { 'aui-sidebar--fold': $store.state.sidebarFold }]">
    <template v-if="!loading && role">
      <main-navbar />
      <!-- <main-sidebar /> -->
      <el-container class="znContainer">
        <!-- 菜单 -->
        <sidebar v-if="role == 'COMPANY'"></sidebar>
        <!-- 内容 -->
        <div class="aui-content__wrapper" :style="`${role == 'COMPANY'} ? {'margin-left':'20px !important'} : {}`">
          <main-content v-if="!$store.state.contentIsNeedRefresh" style="height:500px;width: 100%;overflow-y: scroll;"/>
        </div>
      </el-container>
      
      <!--
      <main-theme-tools />
      -->
    </template>
  </div>
</template>

<script>
import sidebar from './Sidebar'
import MainNavbar from './main-navbar'
import MainSidebar from './main-sidebar'
import MainContent from './main-content'
import MainThemeTools from './main-theme-tools'
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
import { addDynamicRoute } from "@/router";


export default {
  provide () {
    return {
      // 刷新
      refresh () {
        this.$store.state.contentIsNeedRefresh = true
        this.$nextTick(() => {
          this.$store.state.contentIsNeedRefresh = false
        })
      }
    }
  },
  data () {
    return {
      role:'',
      loading: true,
	  radio: 1,
	  dialogVisible: false
    }
  },
  components: {
    MainNavbar,
    MainSidebar,
    MainContent,
    MainThemeTools,
    sidebar,
  },
  watch: {
    $route: 'routeHandle'
  },
  created () {
    this.$http.get(`/sys/user/myRole`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
       if (res.data.length == 1) {
          this.role = res.data[0]
          console.log(this.role)
          Cookies.set('admin_role', res.data[0])
        }
    }).catch(() => {})
    this.dialogVisible = this.$store.state.user.userType == null || this.$store.state.user.userType == ''
    this.windowResizeHandle()
    this.routeHandle(this.$route)
    Promise.all([
      this.getUserInfo(),
      this.getPermissions()
    ]).then(() => {
      this.$nextTick(() => {
        this.loading = false
      })
    })
  },
  methods: {
    // 窗口改变大小
    windowResizeHandle () {
      this.$store.state.sidebarFold = document.documentElement['clientWidth'] <= 992 || false
      window.addEventListener('resize', debounce(() => {
        this.$store.state.sidebarFold = document.documentElement['clientWidth'] <= 992 || false
      }, 150))
    },
    // 路由, 监听
    routeHandle (route) {
      if (!route.meta.isTab) {
        return false
      }
      var tab = this.$store.state.contentTabs.filter(item => item.name === route.name)[0]
      if (!tab) {
        tab = {
          ...window.SITE_CONFIG['contentTabDefault'],
          ...route.meta,
          'name': route.name,
          'params': { ...route.params },
          'query': { ...route.query }
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.concat(tab)
      }
      this.$store.state.sidebarMenuActiveName = tab.menuId
      this.$store.state.contentTabsActiveName = tab.name
    },
    // 获取当前管理员信息
    getUserInfo () {
      return this.$http.get('/sys/user/info').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$store.state.user.id = res.data.id
        this.$store.state.user.name = res.data.username
        this.$store.state.user.caName = res.data.caName
        this.$store.state.user.realName = res.data.realName
        this.$store.state.user.superAdmin = res.data.superAdmin
        this.$store.state.user.superTenant = res.data.superTenant
        this.$store.state.user.isCaDefault = res.data.isCaDefault
        this.$store.state.user.tenantName = res.data.tenantName
        this.$store.state.user.serviceFeeType = res.data.serviceFeeType
        this.$store.state.user.bodyIds = res.data.bodyIds
        this.$store.state.user.userType = res.data.userType // 用户角色类型
        this.$store.state.user.isSourceOfTax = res.data.isSourceOfTax // 用户角色类型
        Cookies.set('isSourceOfTax', res.data.isSourceOfTax)
        console.log(res.data.isSourceOfTax)
        if(res.data.isSourceOfTax == 1){
          // const routeParams = {
          //   routeName: `user-user-listjg`,
          //   title: `用户列表`,
          //   path: "user-user-listjg",
          //   params: {
          //     rowObj:JSON.stringify(row)
          //   },
          // };
          // console.log(this.$router)
          // // 动态路由
          // addDynamicRoute(routeParams, this.$router);
          this.$router.push({ name: "user-user-listjg" });
          }
      }).catch(() => {})
    },
    // 获取权限
    getPermissions () {
      return this.$http.get('/sys/menu/permissions').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        window.SITE_CONFIG['permissions'] = res.data
        
      }).catch(() => {})
    },
    selectRole () {
      // 提交选择结果
      // ----
      // 提交完成
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
	.dialogBg{
		border-radius: 10px;
		box-shadow: 0px 0px 18px 0px rgba(149, 150, 152, 0.36);
	}
	.v-modal{
		background: #F3F3F3;
		opacity: 0.65;
	}
  /deep/ .aui-content > .el-tabs > .el-tabs__content{
    padding:0 !important;
  }
  .znContainer{
    display: flex;
  }
.aui-content__wrapper{
  flex:1;
  width: calc(100% - 300px);
}
</style>
